"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styles = require("quark-web/styles");

var _default = {
  container: {
    display: 'flex',
    textAlign: 'left',
    padding: 2.5 * _styles.baseDim,
    paddingLeft: 2.5 * _styles.baseDim,
    cursor: 'pointer'
  },
  selected: {},
  active: {},
  disabled: {
    color: _styles.grey2
  }
};
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/quark-web/components/form/Option/styles.js
// module id = ./node_modules/quark-web/components/form/Option/styles.js
// module chunks = 0